//export const SISTEMA = "SISTEMA";
//export const CANTIDAD_REGISTROS_GRILLA = "CRG";
//export const VENTA_MODIFICAR_PRECIO_UNITARIO_PRODUCTO = "VMPUP";
//export const PORCENTAJE_IGV_VENTA = "PIGVV";
export const PORCENTAJE_PERCEPCION = "PPER";
export const IMPUESTO_SELECTIVO_CONSUMO_VENTA = "PISCV";
//export const EMPRESA_GRIFO = "EG";
export const VENTA_PRECIO_UNITARIO_INCLUYE_IGV = "VPUIGV";
//export const VENTA_REPORTE_TICKET = "VRT";
export const VENTA_MODIFICAR_TOTAL_PRODUCTO = "VMTP";
//export const VENTA_PLAN_CUENTA_IGV_VENTA = "VPCIGVV";
export const VALIDAR_STOCK = "VS";
export const SERIE_POR_PRODUCTO = "SERP";
export const VENTA_VALIDAR_TOPE_MAXIMO_VENTAS_SOLES = "VVTPMVS";
export const LOGISTICA_PRECIO_UNITARIO_CON_MARGEN_COMERCIAL = "LPUMC";
export const VENTA_GUIA_REMISION_GENERA_SALIDAS = "VGRGS";
export const VENTA_VISUALIZACION_DOCUMENTOS = "VVDOC";
export const VENTA_BLOQUEAR_IMPUESTOS = "VBLO";
//export const EMPRESA_TALLER = "ETALL";
//export const IMPUESTO_PROMOCION_MUNICIPAL = "IPM";
//export const VALOR_PROMOCION_MUNICIPAL = 10;
export const VER_FACTURA_BOLETA_NV_EN_UNA_SOLA_VENTANA = "VFBNV";
//export const CLAIM = "CLAIM";
export const CONVERSION_MEDIDA = "CVME";
export const LOGISTICA_PRODUCTOS_CON_LOTE = "LPCL";

export const LOGISTICA_PRODUCTOS_CON_VENCIMIENTO = "CVPL";
//export const EMPRESA_SECTOR_SALUD = "ESSD";
export const EMPRESA_UTILIZA_PROYECTOS = "PROY";
export const ACCESO_APLICACION = "ACWM"; 
//export const EMPRESA_UTILIZA_GUIA = "GREM";
//export const GIRO_NEGOCIO = "GNCL";
export const CONTROL_DE_CREDITO = "CTCR";
//export const BIENES_APLICA_VCTO = "BVEN";
//export const DESCARGA_PORTAL_SUNAT_SIRE = "SIRE";
export const IMPRESION_ETIQUETA = "IMET";
export const CAJA_CHICA = "CJCH";
export const REG_ATRI = "ATRI";
export const INCREMENTO_PV = "ICPEIM";
export const VISUAL_PLAN = "VPLA";
//export const VER_HISTORIAL_COTI = "HTC";

//export const APERTURA_N_CAJACHICA = "AMCC";
export const IMPORTAR_GRE = "IMPGR";
export const CONTROL_COMPBANTE = "CCOMP";
export const VENTA_DECIMAL = "DCML";
export const PROY_AGRO = "PAGRO";









